import React from "react";
import Meta from "./../components/Meta";
import HeroSection from "./../components/HeroSection";
import ClientsSection from "./../components/ClientsSection";
import FeaturesSection from "./../components/FeaturesSection";
import NewsletterSection from "./../components/NewsletterSection";
import Section from "./../components/Section";
import ClientsSection3 from "./../components/ClientsSection3";

function IndexPage(props) {
  return (
    <>
      <Meta />
      <HeroSection
        color="white"
        size="large"
        backgroundImage="/halftone-1696542371.svg"
        backgroundImageOpacity={1}
        title="The future of IP technology is (already) here."
        subtitle="PDS powers a decentralized enterprise protocol for managing personal and commercial data as intellectual property assets."
        image="tttwinkle.svg"
        buttonText="Get Started"
        buttonColor="primary"
        buttonInverted={false}
        buttonPath="/contact"
      />
      <Section
        color="tertiary"
        size="large"
        title="Property Rights Protocol"
        backgroundImage="/oooscillate.svg"
        backgroundImageOpacity={0.1}
        className="has-text-centered"
      />
      <FeaturesSection
        color="white"
        size="medium"
        backgroundImage="/halftone-1696560535.svg"
        backgroundImageOpacity={1}
        title="Mission"
        subtitle="The PDS team builds and maintains technology systems for decentralized enterprise-grade blockchain exchange technology. We develop comprehensive standards for registering, licensing, and monetizing cloud storage data. Working with partner developers to support their applications on our platform, PDS aims to accelerate the growth of a more sustainable information economy."
      />
      <ClientsSection
        color="white"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity={1}
        title=""
        subtitle="Interoperable with"
      />
      <ClientsSection3
        color="white"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity={1}
        title=""
        subtitle="Compatible with"
      />
      <NewsletterSection
        color="light"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Stay in the know"
        subtitle="Receive our latest articles and feature updates"
        buttonText="Subscribe"
        buttonColor="primary"
        buttonInverted={false}
        inputPlaceholder="Enter your email"
        subscribedMessage="You are now subscribed!"
      />

    </>
  );
}

export default IndexPage;
